import React, { useEffect, useRef, useState } from 'react';
import Barra from '../Modulos/Barra';
import './Css/trayecto.css';
import { FaPlusCircle } from "@react-icons/all-files/fa/FaPlusCircle";
import { FaMapMarkerAlt } from "@react-icons/all-files/fa/FaMapMarkerAlt";
import { FaSort } from "@react-icons/all-files/fa/FaSort";
import { FaSave } from "@react-icons/all-files/fa/FaSave";
import { FaRoute } from "@react-icons/all-files/fa/FaRoute";
import { FaLocationArrow } from "@react-icons/all-files/fa/FaLocationArrow";
import { FaSearch } from "@react-icons/all-files/fa/FaSearch";
import { FaTrashAlt } from "@react-icons/all-files/fa/FaTrashAlt";
import { FaUndoAlt } from "@react-icons/all-files/fa/FaUndoAlt";
import axios from '../utils/axiosConfig';
import { registerOpenStreetMap } from '../utils/openStreetMapType';
import Swal from 'sweetalert2';
import { Toaster, toast } from 'react-hot-toast';

let map = null;
let vMarkerComprobar = null;
let vMarkerOrigen = null;
let vMarkerDestino = null;
let vMarkerSeleccion = null;
var wayPointsArray = [];
let directionsService;
let directionsRenderer;
let puntosadicionales = [];
let listadowaypoints = "";
let listadopoly = "";
var poliArray = [];
const google = window.google;
const Trayecto = () => {
    const [state, setRouteState] = useState({
      origin: null,
      destination: null,
      third: '',
      response: null,
      distancia: 0,
      listRutas: [],
      rutaseleccionada: -1,
      bitOpen: false,
      bitInsert: false,
      bitEdit: false,
      bitDelete: false,
      descripcionruta: '',
      nombreorigen: '',
      nombredestino: '',
      tolerancia: '',
      waypointRows: [],
      hasOrigin: false,
      hasDestination: false,
    });
    const [isEditorOpen, setIsEditorOpen] = useState(false);
    const [activeStep, setActiveStep] = useState(1);
    const [isCheckMode, setIsCheckMode] = useState(false);
    const [selectionMode, setSelectionMode] = useState(null);
    const [hasSelectionCandidate, setHasSelectionCandidate] = useState(false);
    const [routeSearch, setRouteSearch] = useState('');
    const selectionModeRef = useRef(null);
    const setState = (updates) => setRouteState((current) => ({ ...current, ...updates }));

  useEffect(() => {
    HandlePageByRole();
    ListarRutas();
    renderMap();

    return () => {
      directionsRenderer?.setMap(null);
      vMarkerComprobar?.setMap(null);
      vMarkerOrigen?.setMap(null);
      vMarkerDestino?.setMap(null);
      vMarkerSeleccion?.setMap(null);
      wayPointsArray.forEach((marker) => marker.setMap(null));
      map = null;
      vMarkerComprobar = null;
      vMarkerOrigen = null;
      vMarkerDestino = null;
      vMarkerSeleccion = null;
      wayPointsArray = [];
    };
  }, []);

  async function HandlePageByRole() {
    let data = {
      pagina: "6",
    };

    try {
      const res = await axios.post(
        process.env.REACT_APP_SERVER + "/usuarios/getconfiguracionpagina",
        JSON.stringify(data),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("tkn")}`,
          },
          withCredentials: true, // this should be inside the options object
        }
      );

      // Handle the response here after the request completes
      if (res.data.success === false) {
        window.location = "/";
      } else {
        // console.log("BIt permisos: ", res.data.data);
        if (res.data.data.length > 0) {
          setState({
            bitOpen: res.data.data[0].bitOpen,
            bitInsert: res.data.data[0].bitInsert,
            bitEdit: res.data.data[0].bitEdit,
            bitDelete: res.data.data[0].bitDelete,
          });
            if (res.data.data[0].bitOpen) {
              console.warn("Tienes todos los permisos");

              return
            } else {
              Swal.fire({
                title: 'Información',
                text: 'No tiene los permisos necesarios para acceder a esta página',
                icon: 'info',
                timer: 3000, // The time in milliseconds before the alert closes (3 seconds in this case)
                showConfirmButton: false,
                allowOutsideClick: false, // Prevents clicking outside the modal to close it
                didOpen: () => {
                  Swal.showLoading(); // Shows the loading spinner
                },
                timer: 3000 // Time before redirecting (3 seconds)
              }).then(() => {
                // This will execute after the modal finishes showing
                window.location.href = "/principal"; // Redirect to another page
              });
            }

        }

      }
    } catch (error) {
      console.error("Error al listar bit permisos:", error);
    }
  }
  // METODO QUE RENDERIZA EL MAPA DE GOOGLE
  function renderMap() {
    const coords = { lat: 10.992716649650994, lng: -74.80259436365039 };
    try {
      const el = document.getElementById('map');

      if (el) {
        map = new google.maps.Map(el, {
          zoom: 16,
          center: {
            lat: coords.lat,
            lng: coords.lng,
          },
        });
        registerOpenStreetMap(google, map);

        var input = document.getElementById('pac-input');
        var searchBox = new google.maps.places.SearchBox(input);

        // Bias the SearchBox results towards current map's viewport.
        map.addListener('bounds_changed', function () {
          searchBox.setBounds(map.getBounds());
        });

        map.addListener("rightclick", (mapsMouseEvent) => {
          // Close the current InfoWindow.
          console.warn(mapsMouseEvent.latLng.toJSON())
        });

        map.addListener("click", (mapsMouseEvent) => {
          if (selectionModeRef.current) {
            placeSelectionCandidate(mapsMouseEvent.latLng);
          }
        });

        searchBox.addListener('places_changed', function () {
          var places = searchBox.getPlaces();

          if (places.length == 0) {
            return;
          }
          var bounds = new google.maps.LatLngBounds();

          places.some(function (place) {
            if (!place.geometry) {
              // console.log("Returned place contains no geometry");
              return;
            }

            if (place.geometry.viewport) {
              bounds.union(place.geometry.viewport);
            } else {
              bounds.extend(place.geometry.location);
            }
            return true;
          });
          map.fitBounds(bounds);
          if (selectionModeRef.current && places[0]?.geometry?.location) {
            placeSelectionCandidate(places[0].geometry.location);
          }
        });

        return map;
      } else {
        return null;
      }
    } catch (error) {
      window.history.go(0);
    }

  }

  // METODO PARA ASIGNAR EL MARKER DEL ORIGEN
  function asignarOrigen() {
    startPointSelection('origin');
  }

  // METODO PARA ACTUALIZAR EL MARKER DEL ORIGEN
  function asignarOrigenEdit(latlng) {
    if (vMarkerOrigen == null) {
      document.getElementById("submitO")?.classList.add('is-selected');
      var loc = latlng.split(",")
      var lat = parseFloat(loc[0])
      var lng = parseFloat(loc[1])
      vMarkerOrigen = new google.maps.Marker({
        position: new google.maps.LatLng(lat, lng),
        map: map,
        icon: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
        draggable: true
      });
      setState({ hasOrigin: true });
      vMarkerOrigen.addListener('dragend', function (event) {
        asignarPuntosAdicionales();
      });
    } else {
      Swal.fire({
        title: 'Origen ya definido',
        text: 'Elimina o cambia el punto de origen existente antes de agregar otro.',
        icon: 'info',
        confirmButtonText: 'Entendido',
      });
    }
  }

  // METODO PARA ACTUALIZAR EL MARKER DEL DESTINO
  function asignarDestinoEdit(latlng) {
    if (vMarkerDestino == null) {
      document.getElementById("submitD")?.classList.add('is-selected');
      var loc = latlng.split(",")
      var lat = parseFloat(loc[0])
      var lng = parseFloat(loc[1])
      vMarkerDestino = new google.maps.Marker({
        position: new google.maps.LatLng(lat, lng),
        map: map,
        icon: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
        draggable: true
      });
      setState({ hasDestination: true });
    } else {
      Swal.fire({
        title: 'Destino ya definido',
        text: 'Elimina o cambia el punto de destino existente antes de agregar otro.',
        icon: 'info',
        confirmButtonText: 'Entendido',
      });
    }
  }

  // METODO PARA ASIGNAR EL MARKER DEL DESTINO
  function asignarDestino() {
    startPointSelection('destination');
  }

  // METODO PARA AGREGAR WAYPOINTS A LA RUTA
  function agregarWaypoints() {
    document.getElementById("submitW")?.classList.add('is-selected');
    if (!vMarkerOrigen) {
      Swal.fire('Selecciona el origen', 'Ubica primero el punto de origen antes de añadir checkpoints.', 'info');
      return;
    }
    var distancia = calcularDistancia(vMarkerOrigen.getPosition().lat(), vMarkerOrigen.getPosition().lng(), map.getCenter().lat(), map.getCenter().lng());
    var vMarker = new google.maps.Marker({
      position: map.getCenter(),
      map: map,
      icon: 'https://maps.google.com/mapfiles/ms/icons/yellow-dot.png',
      draggable: true,
      id: wayPointsArray.length,
      distancia: distancia
    });
    wayPointsArray.push(vMarker);
    vMarker.addListener('dragend', function (event) {
      /*var distancia=d.calcularDistancia(vMarkerOrigen.getPosition().lat(),vMarkerOrigen.getPosition().lng(),vMarker.getPosition().lat(),vMarker.getPosition().lng());
      vMarker.set("distancia", distancia);*/
      asignarPuntosAdicionales();
    });

    vMarker.addListener('rightclick', function (event) {
      vMarker.setMap(null);
      wayPointsArray = wayPointsArray.filter(object => {
        return object.id !== vMarker.get("id");
      });
      asignarPuntosAdicionales();
    });
    asignarPuntosAdicionales();
  }

  // METODO PARA ACTUALIZAR WAYPOINTS EN LA RUTA
  function agregarWaypointsEdit(latlng) {
    document.getElementById("submitW")?.classList.add('is-selected');
    var loc = latlng.split(",")
    var lat = parseFloat(loc[0])
    var lng = parseFloat(loc[1])
    var distancia = calcularDistancia(vMarkerOrigen.getPosition().lat(), vMarkerOrigen.getPosition().lng(), lat, lng);
    var vMarker = new google.maps.Marker({
      position: new google.maps.LatLng(lat, lng),
      map: map,
      icon: 'https://maps.google.com/mapfiles/ms/icons/yellow-dot.png',
      draggable: true,
      id: wayPointsArray.length,
      distancia: distancia
    });
    wayPointsArray.push(vMarker);
    vMarker.addListener('dragend', function (event) {
      /*var distancia=d.calcularDistancia(vMarkerOrigen.getPosition().lat(),vMarkerOrigen.getPosition().lng(),vMarker.getPosition().lat(),vMarker.getPosition().lng());
      vMarker.set("distancia", distancia);*/
      asignarPuntosAdicionales();
    });

    vMarker.addListener('rightclick', function (event) {
      vMarker.setMap(null);
      wayPointsArray = wayPointsArray.filter(object => {
        return object.id !== vMarker.get("id");
      });
      asignarPuntosAdicionales();
    });
    asignarPuntosAdicionales();
  }


  function handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    setState({
      [name]: value,
    });
  }

  // METODO PARA PINTAR TABLA DE WAYPOINTS
  async function asignarPuntosAdicionales() {

    const waypointRows = [];
    puntosadicionales = [];
    listadowaypoints = "";
    for (var i = 0; i < wayPointsArray.length; i++) {
      puntosadicionales.push({
        location: wayPointsArray[i].getPosition().lat() + "," + wayPointsArray[i].getPosition().lng(),
        stopover: true
      });
      var distancia = calcularDistancia(vMarkerOrigen.getPosition().lat(), vMarkerOrigen.getPosition().lng(), wayPointsArray[i].getPosition().lat(), wayPointsArray[i].getPosition().lng());
      wayPointsArray[i].set("distancia", distancia);
      waypointRows.push({
        number: i + 1,
        latitude: wayPointsArray[i].getPosition().lat(),
        longitude: wayPointsArray[i].getPosition().lng(),
        distance: wayPointsArray[i].distancia.toFixed(2),
      });

      if (i == 0) {
        listadowaypoints += wayPointsArray[i].getPosition().lat() + "," + wayPointsArray[i].getPosition().lng() + "," + wayPointsArray[i].distancia.toFixed(2);
      } else {
        if (i == wayPointsArray.length - 1) {
          listadowaypoints += "|" + wayPointsArray[i].getPosition().lat() + "," + wayPointsArray[i].getPosition().lng() + "," + wayPointsArray[i].distancia.toFixed(2);
        } else {
          listadowaypoints += "|" + wayPointsArray[i].getPosition().lat() + "," + wayPointsArray[i].getPosition().lng() + "," + wayPointsArray[i].distancia.toFixed(2);
        }

      }
      // console.log(listadowaypoints);

    }
    setState({ waypointRows });
  }

  // METODO PARA OBTENER POLILINEA
  async function asignarPolilinea() {
    listadopoly = "";
    poliArray = [];
    var cont = 0;
    if (wayPointsArray.length > 0) {
      for (var i = 0; i < wayPointsArray.length; i++) {
        var distancia = calcularDistancia(vMarkerOrigen.getPosition().lat(), vMarkerOrigen.getPosition().lng(), wayPointsArray[i].getPosition().lat(), wayPointsArray[i].getPosition().lng());
        wayPointsArray[i].set("distancia", distancia);
        var linea = "";
        if (i == 0 && i == wayPointsArray.length - 1) {
          listadopoly = await getPoly(vMarkerOrigen.getPosition().lat() + "," + vMarkerOrigen.getPosition().lng(), wayPointsArray[i].getPosition().lat() + "," + wayPointsArray[i].getPosition().lng());
          listadopoly += "||||" + await getPoly(wayPointsArray[i].getPosition().lat() + "," + wayPointsArray[i].getPosition().lng(), vMarkerDestino.getPosition().lat() + "," + vMarkerDestino.getPosition().lng());
          cont++;
          cont++;
          poliArray.push(1);
          poliArray.push(1);
        } else if (i == 0 && i != wayPointsArray.length - 1) {
          listadopoly = await getPoly(vMarkerOrigen.getPosition().lat() + "," + vMarkerOrigen.getPosition().lng(), wayPointsArray[i].getPosition().lat() + "," + wayPointsArray[i].getPosition().lng());
          cont++;
          poliArray.push(1);
        } else {
          if (i == wayPointsArray.length - 1) {
            listadopoly += "||||" + await getPoly(wayPointsArray[i - 1].getPosition().lat() + "," + wayPointsArray[i - 1].getPosition().lng(), wayPointsArray[i].getPosition().lat() + "," + wayPointsArray[i].getPosition().lng());
            listadopoly += "||||" + await getPoly(wayPointsArray[i].getPosition().lat() + "," + wayPointsArray[i].getPosition().lng(), vMarkerDestino.getPosition().lat() + "," + vMarkerDestino.getPosition().lng());
            cont++;
            cont++;
            poliArray.push(1);
            poliArray.push(1);
          } else {
            listadopoly += "||||" + await getPoly(wayPointsArray[i - 1].getPosition().lat() + "," + wayPointsArray[i - 1].getPosition().lng(), wayPointsArray[i].getPosition().lat() + "," + wayPointsArray[i].getPosition().lng());
            cont++;
            poliArray.push(1);
          }
        }
        // console.log(listadopoly);
      }
    } else {
      listadopoly = await getPoly(vMarkerOrigen.getPosition().lat() + "," + vMarkerOrigen.getPosition().lng(), vMarkerDestino.getPosition().lat() + "," + vMarkerDestino.getPosition().lng());
      cont++;
      poliArray.push(1);
    }
    // console.log("contador: " + cont);
  }

  // METODO PARA CONVERTIR DE GRADOS A RADIANES
  function gradosARadianes(grados) {
    return grados * Math.PI / 180;
  }

  // METODO PARA CALCULAR DISTANCIA ENTRE DOS POSICIONES
  function calcularDistancia(lat1, lng1, lat2, lng2) {
    lat1 = gradosARadianes(lat1);
    lng1 = gradosARadianes(lng1);
    lat2 = gradosARadianes(lat2);
    lng2 = gradosARadianes(lng2);
    const RADIO_TIERRA_EN_KILOMETROS = 6371;
    let diferenciaEntreLongitudes = (lng2 - lng1);
    let diferenciaEntreLatitudes = (lat2 - lat1);
    let a = Math.pow(Math.sin(diferenciaEntreLatitudes / 2), 2) + Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(diferenciaEntreLongitudes / 2), 2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return RADIO_TIERRA_EN_KILOMETROS * c;
  }

  // METODO PARA CALCULAR LA RUTA
  function handleClick() {
    if (!vMarkerOrigen || !vMarkerDestino) {
      Swal.fire('Ruta incompleta', 'Ubica el origen y el destino antes de dibujar la ruta.', 'info');
      return;
    }
    asignarPuntosAdicionales();
    if (directionsRenderer) {
      directionsRenderer.setMap(null);
    }
    directionsService = new google.maps.DirectionsService();
    directionsRenderer = new google.maps.DirectionsRenderer({
      suppressMarkers: true
    });
    //call the function that computes directions
    calcAddress(directionsService, directionsRenderer);
    //event.preventDefault();
  }

  // METODO PARA PINTAR LA RUTA EN EL MAPA
  function calcAddress(directionsService, directionsRenderer) {

    directionsRenderer.setMap(map);

    directionsService.route(
      {
        origin: {
          query: vMarkerOrigen.getPosition().lat() + "," + vMarkerOrigen.getPosition().lng(),
        },
        destination: {
          query: vMarkerDestino.getPosition().lat() + "," + vMarkerDestino.getPosition().lng(),
        },
        waypoints: puntosadicionales,
        travelMode: google.maps.TravelMode.DRIVING,
      },
      (response, status) => {
        const ruta = response.routes[0].legs;
        var distancia = 0;
        for (var i = 0; i < ruta.length; i++) {
          distancia += ruta[i].distance.value;
        }
        if (status === 'OK') {
          setState({
            response: response,
            distancia: distancia
          });

          directionsRenderer.setDirections(response);
          asignarPolilinea();
        } else {
          Swal.fire({
            title: 'No fue posible dibujar la ruta',
            text: `Google Maps respondió con el estado: ${status}.`,
            icon: 'error',
            confirmButtonText: 'Aceptar',
          });
        }
      }
    );
  }

  //METODO PARA COMPROBAR SI ESTA EN LA RUTA
  function checkThird() {
    handleClick();
  }

  // METODO PARA COMPROBAR CORRECTO LLENADO DEL FORMULARIO
  function checkThird2() {
    if (state.bitInsert) {
      var descripciontrayecto = state.descripcionruta;
      var nombreorigen = state.nombreorigen;
      var nombredestino = state.nombredestino;
      var tolerancia = state.tolerancia;

      if (descripciontrayecto == "" || nombreorigen == "" || nombredestino == "" || tolerancia == "" || vMarkerOrigen == null || vMarkerDestino == null) {
        Swal.fire({
          title: 'Información incompleta',
          text: 'Completa la descripción, el origen, el destino, la tolerancia y sus ubicaciones.',
          icon: 'warning',
          confirmButtonText: 'Revisar formulario',
        });
      } else {
        if ((wayPointsArray.length + 1) == poliArray.length) {
          GuardarRuta();
        } else {
          Swal.fire({
            title: 'Ruta todavía en proceso',
            text: 'Las polilíneas aún no han terminado de cargar. Espera un momento e intenta nuevamente.',
            icon: 'info',
            confirmButtonText: 'Entendido',
          });
        }
      }
    } else {
      Swal.fire({
        title: 'Información',
        text: 'No tiene los permisos necesarios para acceder a esta opción',
        icon: 'info',
        showConfirmButton: false,
        timer: 3000,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      }).then(() => {
        console.error("No tienes permisos"); // Redirect to another page
      });
    }

  }

  function checkThird4() {

    if (state.rutaseleccionada === -1) {
      Swal.fire('Selecciona una georuta', 'Abre una georuta antes de comprobar una ubicación.', 'info');
      return;
    }

    if (!vMarkerComprobar) {
      vMarkerComprobar = new google.maps.Marker({
        position: map.getCenter(),
        map,
        icon: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png',
        draggable: true,
        title: 'Arrastra este punto para comprobar su ubicación',
      });
      setIsCheckMode(true);
      setIsEditorOpen(false);
      Swal.fire({
        title: 'Modo de comprobación',
        text: 'Arrastra el marcador azul hasta la ubicación que deseas validar y pulsa “Validar ubicación”.',
        icon: 'info',
        confirmButtonText: 'Entendido',
      });
      return;
    }

    let data =
    {
      "ID": state.rutaseleccionada,
      "latitud": vMarkerComprobar.getPosition().lat(),
      "longitud": vMarkerComprobar.getPosition().lng()
    }
    // console.log(data);
    const json = JSON.stringify(data);
    axios.post(process.env.REACT_APP_SERVER + '/operaciones/getfind2', json, {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('tkn')}` },
      withCredentials: true
    })
      .then(res => {
        const result = normalizeRouteCheckResult(res.data);
        if (result.belongs) {
          toast.success(
            <div className="trayecto-toast__content">
              <strong>Ubicación válida</strong>
              <span>{result.message || 'El punto seleccionado sí hace parte de la georuta.'}</span>
            </div>, {
            duration: 5000,
            className: 'trayecto-toast trayecto-toast--success',
          });
        } else {
          toast.error(
            <div className="trayecto-toast__content">
              <strong>Ubicación fuera de la ruta</strong>
              <span>{result.message || 'El punto seleccionado no hace parte de la georuta.'}</span>
            </div>, {
            duration: 5000,
            className: 'trayecto-toast trayecto-toast--error',
          });
        }
        cancelCheckMode();
      })
      .catch(() => {
        toast.error(
          <div className="trayecto-toast__content">
            <strong>Error de validación</strong>
            <span>No fue posible comprobar la ubicación. Intenta nuevamente.</span>
          </div>, {
          duration: 5000,
          className: 'trayecto-toast trayecto-toast--error',
        });
      })
  }

  function normalizeRouteCheckResult(response) {
    const payload = response?.data ?? response;
    const objectValue = payload && typeof payload === 'object'
      ? payload.belongs ?? payload.isInside ?? payload.inside ?? payload.result ?? payload.success
      : payload;
    const normalized = String(objectValue ?? '').trim().toLowerCase();
    const positiveValues = ['true', '1', 'sí', 'si', 'yes', 'dentro', 'inside'];
    const negativeText = /\b(no|false|fuera|outside|no pertenece|no hace parte)\b/i;
    const positiveText = /\b(sí|si|true|dentro|inside|pertenece|hace parte)\b/i;
    const message = typeof payload === 'string'
      ? payload
      : payload?.message || payload?.mensaje || '';
    const belongs = typeof objectValue === 'boolean'
      ? objectValue
      : positiveValues.includes(normalized) || (!negativeText.test(message) && positiveText.test(message));

    return { belongs, message };
  }

  function cancelCheckMode() {
    vMarkerComprobar?.setMap(null);
    vMarkerComprobar = null;
    setIsCheckMode(false);
  }

  function startPointSelection(type) {
    vMarkerSeleccion?.setMap(null);
    vMarkerSeleccion = null;
    if (type === 'origin') vMarkerOrigen?.setVisible(false);
    if (type === 'destination') vMarkerDestino?.setVisible(false);
    selectionModeRef.current = type;
    setSelectionMode(type);
    setHasSelectionCandidate(false);
    setIsEditorOpen(false);
  }

  function placeSelectionCandidate(position) {
    if (!selectionModeRef.current || !map) return;
    const icon = selectionModeRef.current === 'origin'
      ? 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'
      : 'https://maps.google.com/mapfiles/ms/icons/red-dot.png';

    if (!vMarkerSeleccion) {
      vMarkerSeleccion = new google.maps.Marker({
        position,
        map,
        icon,
        draggable: true,
        animation: google.maps.Animation.DROP,
        title: 'Arrastra el marcador para ajustar la ubicación',
      });
    } else {
      vMarkerSeleccion.setPosition(position);
      vMarkerSeleccion.setIcon(icon);
    }
    map.panTo(position);
    setHasSelectionCandidate(true);
  }

  function confirmPointSelection() {
    const type = selectionModeRef.current;
    const position = vMarkerSeleccion?.getPosition();
    if (!type || !position) return;

    if (type === 'origin') {
      vMarkerOrigen?.setMap(null);
      vMarkerOrigen = vMarkerSeleccion;
      vMarkerOrigen.setIcon('http://maps.google.com/mapfiles/ms/icons/green-dot.png');
      vMarkerOrigen.addListener('dragend', asignarPuntosAdicionales);
      setState({ hasOrigin: true });
    } else {
      vMarkerDestino?.setMap(null);
      vMarkerDestino = vMarkerSeleccion;
      vMarkerDestino.setIcon('https://maps.google.com/mapfiles/ms/icons/red-dot.png');
      setState({ hasDestination: true });
    }

    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: position }, (results, status) => {
      if (status !== 'OK' || !results?.[0]?.formatted_address) return;
      const address = results[0].formatted_address;
      setRouteState((current) => type === 'origin'
        ? { ...current, nombreorigen: current.nombreorigen || address }
        : { ...current, nombredestino: current.nombredestino || address });
    });

    vMarkerSeleccion = null;
    selectionModeRef.current = null;
    setSelectionMode(null);
    setHasSelectionCandidate(false);
    clearRenderedRoute();
    setActiveStep(1);
    setIsEditorOpen(true);
  }

  function cancelPointSelection() {
    vMarkerSeleccion?.setMap(null);
    vMarkerSeleccion = null;
    vMarkerOrigen?.setVisible(true);
    vMarkerDestino?.setVisible(true);
    selectionModeRef.current = null;
    setSelectionMode(null);
    setHasSelectionCandidate(false);
    setActiveStep(1);
    setIsEditorOpen(true);
  }

  function clearRenderedRoute() {
    directionsRenderer?.setMap(null);
    directionsRenderer = null;
    listadopoly = "";
    poliArray = [];
    setState({ response: null, distancia: 0 });
  }

  function clearOrigin() {
    vMarkerOrigen?.setMap(null);
    vMarkerOrigen = null;
    document.getElementById("submitO")?.classList.remove('is-selected');
    clearRenderedRoute();
    setState({ origin: null, nombreorigen: '', hasOrigin: false });
  }

  function clearDestination() {
    vMarkerDestino?.setMap(null);
    vMarkerDestino = null;
    document.getElementById("submitD")?.classList.remove('is-selected');
    clearRenderedRoute();
    setState({ destination: null, nombredestino: '', hasDestination: false });
  }

  function removeWaypoint(index) {
    const marker = wayPointsArray[index];
    marker?.setMap(null);
    wayPointsArray.splice(index, 1);
    wayPointsArray.forEach((waypoint, waypointIndex) => waypoint.set('id', waypointIndex));
    clearRenderedRoute();
    if (vMarkerOrigen) asignarPuntosAdicionales();
    else setState({ waypointRows: [] });
  }

  function performRouteReset() {
    vMarkerOrigen?.setMap(null);
    vMarkerDestino?.setMap(null);
    vMarkerComprobar?.setMap(null);
    vMarkerSeleccion?.setMap(null);
    wayPointsArray.forEach((marker) => marker.setMap(null));
    vMarkerOrigen = null;
    vMarkerDestino = null;
    vMarkerComprobar = null;
    vMarkerSeleccion = null;
    wayPointsArray = [];
    puntosadicionales = [];
    listadowaypoints = "";
    selectionModeRef.current = null;
    clearRenderedRoute();
    setSelectionMode(null);
    setHasSelectionCandidate(false);
    setIsCheckMode(false);
    setRouteSearch('');
    setActiveStep(1);
    setState({
      origin: null,
      destination: null,
      rutaseleccionada: -1,
      descripcionruta: '',
      nombreorigen: '',
      nombredestino: '',
      tolerancia: '',
      waypointRows: [],
      hasOrigin: false,
      hasDestination: false,
    });
  }

  function clearRoute() {
    Swal.fire({
      title: '¿Limpiar el recorrido?',
      text: 'Se eliminarán la selección actual, el origen, el destino, los checkpoints y la ruta dibujada.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, limpiar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#c54545',
    }).then(({ isConfirmed }) => {
      if (!isConfirmed) return;
      performRouteReset();
    });
  }

  function resetSelectedRoute() {
    Swal.fire({
      title: '¿Restablecer la georuta?',
      text: 'Se cerrará la ruta actual para que puedas seleccionar otra o crear una nueva.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, restablecer',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#0f4c81',
    }).then(({ isConfirmed }) => {
      if (!isConfirmed) return;
      performRouteReset();
      setIsEditorOpen(false);
      toast.success('La georuta fue restablecida. Puedes seleccionar otra o crear una nueva.', {
        duration: 3500,
        className: 'trayecto-toast trayecto-toast--success',
      });
    });
  }

  function validateRouteSetup() {
    const missing = [];
    if (!String(state.descripcionruta || '').trim()) missing.push('Nombre de la ruta');
    if (!String(state.nombreorigen || '').trim()) missing.push('Descripción del origen');
    if (!state.hasOrigin || !vMarkerOrigen) missing.push('Ubicación del origen');
    if (!String(state.nombredestino || '').trim()) missing.push('Descripción del destino');
    if (!state.hasDestination || !vMarkerDestino) missing.push('Ubicación del destino');
    const tolerance = Number(state.tolerancia);
    if (!String(state.tolerancia ?? '').trim() || !Number.isFinite(tolerance) || tolerance <= 0) {
      missing.push('Tolerancia válida mayor que cero');
    }

    if (missing.length > 0) {
      Swal.fire({
        title: 'Completa la configuración',
        html: `<div style="text-align:left"><p style="margin:0 0 8px">Antes de continuar revisa:</p><ul style="margin:0;padding-left:20px">${missing.map((field) => `<li>${field}</li>`).join('')}</ul></div>`,
        icon: 'warning',
        confirmButtonText: 'Revisar',
      });
      return false;
    }
    return true;
  }

  function goToCheckpoints() {
    if (validateRouteSetup()) setActiveStep(2);
  }

  //METODO PARA OBTENER POLILINEA DE ACUERDO A UN ORIGEN Y DESTINO
  async function getPoly(origen, destino) {
    let data =
    {
      "origen": origen,
      "destino": destino
    }
    const json = JSON.stringify(data);
    const resp = await axios.post(process.env.REACT_APP_SERVER + '/operaciones/getpoly', json, {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('tkn')}` },
      withCredentials: true
    });
    if (resp.data.success) {
      return resp.data.data;
    } else {
      window.history.go(0);
    }

  }

  //METODO PARA ORDENAR LOS WAYPOINTS DE ACUERDO A LA DISTANCIA DEL ORIGEN
  function checkThird3() {
    // console.log(wayPointsArray);
    wayPointsArray.sort(function (a, b) {
      if (a.distancia > b.distancia) {
        return 1;
      }
      if (a.distancia < b.distancia) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    // console.log(wayPointsArray);
    asignarPuntosAdicionales();
  }

  function DibujarRuta() {
    handleClick();
  }

  //METODO PARA GUARDAR O ACTUALIZAR LOS TRAYECTOS
  function GuardarRuta() {

    var distancia = calcularDistancia(vMarkerOrigen.getPosition().lat(), vMarkerOrigen.getPosition().lng(), vMarkerDestino.getPosition().lat(), vMarkerDestino.getPosition().lng());
    if (listadopoly == "") {
      Swal.fire({
        title: 'Dibuja la ruta primero',
        text: 'Antes de guardar debes calcular y visualizar el recorrido sobre el mapa.',
        icon: 'warning',
        confirmButtonText: 'Aceptar',
      });
    } else {

      if ((listadopoly.split("||||").length == (listadowaypoints.split("|").length + 1)) || listadowaypoints == "") {
        let data =
        {
          "ID": state.rutaseleccionada,
          "descripciontrayecto": state.descripcionruta,
          "origen": vMarkerOrigen.getPosition().lat() + "," + vMarkerOrigen.getPosition().lng(),
          "nombreorigen": state.nombreorigen,
          "destino": vMarkerDestino.getPosition().lat() + "," + vMarkerDestino.getPosition().lng(),
          "nombredestino": state.nombredestino,
          "waypoints": listadowaypoints,
          "tolerancia": state.tolerancia,
          "distanciaorigen": distancia.toFixed(2),
          "poly": listadopoly,
          "distanciareal": state.distancia
        }
        const json = JSON.stringify(data);
        axios.post(process.env.REACT_APP_SERVER + '/operaciones/savetrayecto', json, {
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('tkn')}` },
          withCredentials: true
        })
          .then(res => {
            if (res.data.hasOwnProperty('success')) {
              listadopoly = "";
              poliArray = [];
              Swal.fire({
                title: 'Georuta guardada',
                text: 'La ruta fue guardada exitosamente.',
                icon: 'success',
                confirmButtonText: 'Aceptar',
                timer: 2200,
                timerProgressBar: true,
              }).then(() => window.history.go(0));
            } else {
              Swal.fire({
                title: 'No fue posible guardar',
                text: 'El servidor no confirmó el registro de la georuta.',
                icon: 'error',
                confirmButtonText: 'Aceptar',
              });
            }
          })
      } else {
        Swal.fire({
          title: 'La ruta no está lista',
          text: 'No coinciden los checkpoints con los segmentos calculados. Dibuja la ruta nuevamente.',
          icon: 'error',
          confirmButtonText: 'Aceptar',
        });
      }

    }

  }

  // METODO QUE LISTA LOS TRAYECTOS
  function ListarRutas() {
    axios.get(process.env.REACT_APP_SERVER + '/operaciones/gettrayectos', {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('tkn')}` },
      withCredentials: true
    })
      .then(res => {
        if (res.data.success === false) {
          // window.location = "/";
          console.error("Error al listar rutas: ", res.data.message);
        } else {
          setState({ listRutas: res.data.data });
          console.log("Cargando rutas",res.data.data);
        }
      })
  }

  // METODO QUE CARGA LA INFORMACION DE UN TRAYECTO EN EL FORMULARIO Y EL MAPA
  function EditarRuta(ruta) {
    setState({ waypointRows: [] });
    document.getElementById("submitO")?.classList.remove('is-selected');
    document.getElementById("submitD")?.classList.remove('is-selected');
    document.getElementById("submitW")?.classList.remove('is-selected');
    setState({ rutaseleccionada: ruta });
    if (ruta == -1) {
      window.history.go(0);
    } else {
      if (vMarkerOrigen != null) {
        vMarkerOrigen.setMap(null);
        vMarkerOrigen = null;
      }
      if (vMarkerDestino != null) {
        vMarkerDestino.setMap(null);
        vMarkerDestino = null;
      }
      if (wayPointsArray.length > 0) {
        for (var i = 0; i < wayPointsArray.length; i++) {
          var m = wayPointsArray[i];
          m.setMap(null);
        }
        wayPointsArray = [];
        poliArray = [];
      }

      if (directionsRenderer != null) {
        directionsRenderer.setMap(null);
      }
      state.listRutas.forEach(function (loc) {
        if (loc.IDTrayecto == ruta) {
          setState({
            descripcionruta: loc.DescripcionTrayecto || '',
            nombreorigen: loc.NombreOrigen || '',
            nombredestino: loc.NombreDestino || '',
            tolerancia: loc.Tolerancia || '',
          });
          asignarOrigenEdit(loc.Origen);
          asignarDestinoEdit(loc.Destino);
          if (loc.WayPoints != "") {
            var wp = loc.WayPoints.split("|");
            for (var i = 0; i < wp.length; i++) {
              var ob = wp[i].split(",");
              agregarWaypointsEdit(ob[0] + "," + ob[1]);
            }
          }
        }
      })

    }
  }

  const closeEditor = () => setIsEditorOpen(false);
  const selectedRoute = state.listRutas.find((route) => String(route.IDTrayecto) === String(state.rutaseleccionada));
  const filteredRoutes = state.listRutas.filter((route) =>
    String(route.DescripcionTrayecto || '').toLowerCase().includes(routeSearch.trim().toLowerCase())
  );

  return (
    <div className="trayecto-page">
      <Barra />
      <Toaster
        position="top-center"
        gutter={10}
        toastOptions={{
          className: 'trayecto-toast',
          success: { ariaProps: { role: 'status', 'aria-live': 'polite' } },
          error: { ariaProps: { role: 'alert', 'aria-live': 'assertive' } },
        }}
      />
      <main className="trayecto-map-workspace">
        <section className="trayecto-map-card" aria-label="Mapa de configuración de la georuta">
          <div className="trayecto-map-search">
            <FaSearch aria-hidden="true" />
            <input id="pac-input" type="search" placeholder="Buscar dirección o lugar" aria-label="Buscar dirección o lugar" />
          </div>

          <div className="trayecto-map-summary">
            <span className="trayecto-eyebrow">Gestión de rutas</span>
            <h1>{selectedRoute?.DescripcionTrayecto || 'Nueva georuta'}</h1>
            <p>{selectedRoute ? 'Ruta cargada en el mapa' : 'Configura una ruta y ubica sus puntos sobre el mapa.'}</p>
            <div className="trayecto-map-summary__actions">
              <button className="trayecto-action trayecto-action--primary" onClick={() => { setActiveStep(1); setIsEditorOpen(true); }}>
                <FaRoute /> {selectedRoute ? 'Editar georuta' : 'Crear georuta'}
              </button>
              <button className="trayecto-action trayecto-action--secondary" onClick={checkThird}>
                <FaLocationArrow /> Dibujar ruta
              </button>
              <button className="trayecto-action trayecto-action--secondary trayecto-action--wide" onClick={checkThird4}>
                <FaMapMarkerAlt /> Comprobar ubicación
              </button>
            </div>
            <div className="trayecto-route-browser">
              <label htmlFor="trayecto-route-search">Georutas disponibles</label>
              <div className="trayecto-route-search">
                <FaSearch aria-hidden="true" />
                <input
                  id="trayecto-route-search"
                  type="search"
                  value={routeSearch}
                  onChange={(event) => setRouteSearch(event.target.value)}
                  placeholder="Buscar georuta..."
                  aria-label="Buscar georuta"
                />
                {routeSearch && <button type="button" onClick={() => setRouteSearch('')} aria-label="Limpiar búsqueda">×</button>}
              </div>
              <select
                value={state.rutaseleccionada === -1 ? '' : state.rutaseleccionada}
                onChange={(event) => event.target.value && EditarRuta(event.target.value)}
                aria-label="Seleccionar georuta"
              >
                <option value="">Selecciona una georuta</option>
                {filteredRoutes.map((route) => (
                  <option key={route.IDTrayecto} value={route.IDTrayecto}>{route.DescripcionTrayecto}</option>
                ))}
              </select>
              <span>{filteredRoutes.length} {filteredRoutes.length === 1 ? 'georuta encontrada' : 'georutas encontradas'}</span>
              {selectedRoute && (
                <button className="trayecto-reset-route" type="button" onClick={resetSelectedRoute}>
                  <FaUndoAlt /> Restablecer ruta
                </button>
              )}
            </div>
          </div>

          {isCheckMode && (
            <div className="trayecto-check-panel" role="status">
              <div className="trayecto-check-panel__icon"><FaMapMarkerAlt /></div>
              <div>
                <strong>Comprobar ubicación</strong>
                <span>Arrastra el marcador azul al punto que deseas validar.</span>
              </div>
              <button className="trayecto-action trayecto-action--primary" onClick={checkThird4}>Validar ubicación</button>
              <button className="trayecto-action trayecto-action--secondary" onClick={cancelCheckMode}>Cancelar</button>
            </div>
          )}

          {selectionMode && (
            <div className={`trayecto-selection-panel is-${selectionMode}`} role="status">
              <div className="trayecto-selection-panel__pin"><FaMapMarkerAlt /></div>
              <div className="trayecto-selection-panel__copy">
                <strong>{selectionMode === 'origin' ? 'Selecciona el punto de origen' : 'Selecciona el punto de destino'}</strong>
                <span>{hasSelectionCandidate ? 'Ajusta el marcador o confirma esta ubicación.' : 'Busca una dirección o haz clic directamente sobre el mapa.'}</span>
              </div>
              <button className="trayecto-action trayecto-action--primary" disabled={!hasSelectionCandidate} onClick={confirmPointSelection}>Confirmar punto</button>
              <button className="trayecto-action trayecto-action--secondary" onClick={cancelPointSelection}>Cancelar</button>
            </div>
          )}

          <div className="trayecto-map-legend">
            <span><i className="is-origin" /> Origen</span>
            <span><i className="is-waypoint" /> Checkpoint</span>
            <span><i className="is-destination" /> Destino</span>
          </div>
          <div id="map" />
        </section>
      </main>

      {isEditorOpen && state.bitOpen && (
        <div className="trayecto-modal-backdrop" role="presentation">
          <section className="trayecto-modal" role="dialog" aria-modal="false" aria-labelledby="trayecto-modal-title">
            <header className="trayecto-modal__header">
              <div>
                <span className="trayecto-eyebrow">Asistente de georuta</span>
                <h2 id="trayecto-modal-title">Configurar recorrido</h2>
              </div>
              <button className="trayecto-modal__close" onClick={closeEditor} aria-label="Cerrar">×</button>
            </header>

            <nav className="trayecto-steps" aria-label="Pasos de configuración">
              {[['1', 'Ruta y ubicaciones'], ['2', 'Checkpoints']].map(([step, label]) => (
                <button key={step} className={activeStep === Number(step) ? 'is-active' : ''} onClick={() => Number(step) === 2 ? goToCheckpoints() : setActiveStep(1)}>
                  <span>{step}</span>{label}
                </button>
              ))}
            </nav>

            <div className="trayecto-modal__body">
              {activeStep === 1 && (
                <div className="trayecto-step-panel">
                  <h3>Información general</h3>
                  <p>Selecciona una georuta existente o asigna un nombre a la nueva.</p>
                  <div className="trayecto-field">
                    <label className="trayecto-label" htmlFor="georuta">Georuta</label>
                    <select className="form-select" id="georuta" value={state.rutaseleccionada} onChange={(event) => EditarRuta(event.target.value)}>
                      <option value={-1}>Nueva georuta</option>
                      {state.listRutas.map((route) => <option key={route.IDTrayecto} value={route.IDTrayecto}>{route.DescripcionTrayecto}</option>)}
                    </select>
                  </div>
                  <div className="trayecto-field">
                    <label className="trayecto-label" htmlFor="descripcionruta">Nombre de la ruta</label>
                    <input className="form-control" id="descripcionruta" name="descripcionruta" value={state.descripcionruta} onChange={handleInputChange} placeholder="Ej. Barranquilla – Cartagena" />
                  </div>
                  <div className="trayecto-step-divider" />
                  <h3>Origen y destino</h3>
                  <p>Selecciona cada ubicación directamente sobre el mapa y confirma el marcador correspondiente.</p>
                  <div className="trayecto-field">
                    <label className="trayecto-label" htmlFor="origin">Descripción del origen</label>
                    <div className="trayecto-input-action trayecto-input-action--origin">
                      <input className="form-control" id="origin" name="nombreorigen" value={state.nombreorigen} onChange={handleInputChange} />
                      {state.hasOrigin && <button className="trayecto-clear-point" type="button" onClick={clearOrigin} aria-label="Eliminar origen" title="Eliminar origen">×</button>}
                      <button id="submitO" className={`trayecto-marker-button${state.hasOrigin ? ' is-selected' : ''}`} onClick={asignarOrigen} aria-label={state.hasOrigin ? 'Cambiar origen' : 'Ubicar origen'} title={state.hasOrigin ? 'Cambiar origen' : 'Ubicar origen'}><FaMapMarkerAlt /></button>
                    </div>
                  </div>
                  <div className="trayecto-field">
                    <label className="trayecto-label" htmlFor="destination">Descripción del destino</label>
                    <div className="trayecto-input-action trayecto-input-action--destination">
                      <input className="form-control" id="destination" name="nombredestino" value={state.nombredestino} onChange={handleInputChange} />
                      {state.hasDestination && <button className="trayecto-clear-point" type="button" onClick={clearDestination} aria-label="Eliminar destino" title="Eliminar destino">×</button>}
                      <button id="submitD" className={`trayecto-marker-button${state.hasDestination ? ' is-selected' : ''}`} onClick={asignarDestino} aria-label={state.hasDestination ? 'Cambiar destino' : 'Ubicar destino'} title={state.hasDestination ? 'Cambiar destino' : 'Ubicar destino'}><FaMapMarkerAlt /></button>
                    </div>
                  </div>
                  <div className="trayecto-field">
                    <label className="trayecto-label" htmlFor="tolerancia">Tolerancia</label>
                    <input className="form-control" id="tolerancia" name="tolerancia" value={state.tolerancia} onChange={handleInputChange} inputMode="decimal" />
                  </div>
                </div>
              )}

              {activeStep === 2 && (
                <div className="trayecto-step-panel">
                  <h3>Checkpoints</h3>
                  <p>Centra el mapa donde irá el checkpoint. La distancia entre puntos no debe superar los 100 km.</p>
                  <button id="submitW" className="trayecto-add-button" onClick={agregarWaypoints}><FaPlusCircle /> Añadir checkpoint desde el centro</button>
                  <div className="trayecto-table-wrap">
                    <table className="tablawp"><thead><tr><th>N°</th><th>Latitud</th><th>Longitud</th><th>Distancia</th><th aria-label="Acciones" /></tr></thead><tbody>{state.waypointRows.map((row, index) => <tr key={`${row.number}-${row.latitude}`}><td>{row.number}</td><td>{row.latitude}</td><td>{row.longitude}</td><td>{row.distance}</td><td><button className="trayecto-delete-waypoint" type="button" onClick={() => removeWaypoint(index)} aria-label={`Eliminar checkpoint ${row.number}`} title="Eliminar checkpoint">×</button></td></tr>)}</tbody></table>
                  </div>
                  <p className="trayecto-help">Haz clic derecho sobre un marcador para eliminarlo.</p>
                </div>
              )}
            </div>

            <footer className="trayecto-modal__footer">
              <button className="trayecto-action trayecto-action--danger" onClick={clearRoute}><FaTrashAlt /> Limpiar</button>
              {activeStep === 2 && (
                <button className="trayecto-action trayecto-action--secondary" disabled={state.waypointRows.length < 2} onClick={checkThird3} title={state.waypointRows.length < 2 ? 'Agrega al menos dos checkpoints para ordenarlos' : 'Ordenar checkpoints'}>
                  <FaSort /> Ordenar
                </button>
              )}
              {activeStep === 2 && <button className="trayecto-action trayecto-action--secondary" onClick={() => setActiveStep(1)}>Anterior</button>}
              {activeStep === 1
                ? <button className="trayecto-action trayecto-action--primary" onClick={goToCheckpoints}>Continuar</button>
                : <><button className="trayecto-action trayecto-action--secondary" onClick={checkThird}><FaRoute /> Dibujar</button><button className="trayecto-action trayecto-action--primary" onClick={checkThird2}><FaSave /> Guardar</button><button className="trayecto-action trayecto-action--secondary" onClick={checkThird4}><FaLocationArrow /> Comprobar</button></>}
            </footer>
          </section>
        </div>
      )}
    </div>
  );
}

export default Trayecto;
